'use client';

import { useRouter, usePathname } from 'next/navigation';

import { useAppDispatch, useAppSelector } from '../../lib/hooks';
import { selectToken, selectIsLoggedIn } from '../../lib/features/auth/authSlice';

// Services
import { addCartItemAction, updateCartAction } from '../../lib/features/cart/cartSlice';

function PricingBuyButton({ item }) {
  const dispatch = useAppDispatch();
  const token = useAppSelector(selectToken);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const route = useRouter();
  const pathname = usePathname();

  const onCart = async (item) => {
    if (!isLoggedIn) {
      setTimeout(async () => (route.push(`/auth-login?from=${encodeURIComponent(pathname)}`)), 100);
    } else {
      try {
        const res = await dispatch(addCartItemAction(
          { product: { product_id: item.id, price_eur: item.price }, token },
        ));
        if (res.error) {
          dispatch(updateCartAction({ token }));
        }
        route.push('/shop-cart');
      } catch (err) {
        dispatch(updateCartAction({ token }));
      }
    }
  };
  return (
    <button type="button" onClick={() => onCart(item)} className="btn btn-primary">
      Buy Now
    </button>
  );
}

export default PricingBuyButton;
